import { displayToast, sendAppsignalError } from "../modules/utils";

export default class AddToCartBase {
  constructor(node) {
    this.element = node;

    this.minusButton = this.element.querySelector(".js-item-minus");
    this.plusButton = this.element.querySelector(".js-item-plus");
    this.quantityElement = this.element.querySelector(".js-quantity");
    this.cartWrapper = this.element.querySelector(".js-cart-wrapper");
    this.paymentWrapper = document.querySelector(".js-add-to-cart-price-wrapper");
    this.qvHeaderElement = document.querySelector("[data-js='qv-in-header']");
    this.totalQvAndProducts = document.querySelectorAll(".js-qv-total-products");
    this.addToCartToggle = this.element.querySelector(".js-add-to-cart-toggle");
    this.destroyButton = this.element.querySelector(".js-destroy-button");

    this.inputMinThreshold = parseInt(this.quantityElement.min);
    this.inputMaxThreshold = parseInt(this.quantityElement.max);

    this.oldValue = this.quantityElement.value;

    this.initialize();
  }

  initialize() {
    if (this.cartWrapper) {
      this.cartWrapper.addEventListener("click", (e) => {
        clearTimeout(this.timeout);

        this.cartWrapper.classList.add("active");

        this.timeout = setTimeout(() => {
          this.cartWrapper.classList.remove("active");
        }, 3000);

        // If quantity is 0, we must add 1 item to the cart
        if (this.quantityElement.value == 0) {
          // unless we go from > 1 to 0, then we should remove the item from the cart
          if (this.minusButton.contains(e.target)) {
            return;
          }
          this.quantityElement.value = 1;

          this.quantityElement.dispatchEvent(new Event("change"));
        }
      });
    }

    this.updateQuantity();

    if (this.destroyButton != undefined) {
      this.destroyButton.addEventListener("click", () => {
        this.url = this.element.dataset.cartDestroyUrl;
        this.postUpdatedQuantity("DELETE");
      });
    }

    this.minusButton.addEventListener("click", () => {
      if (this.quantityElement.value > this.inputMinThreshold) {
        this.quantityElement.stepDown();
        this.quantityElement.dispatchEvent(new Event("change"));
      }
    });

    this.plusButton.addEventListener("click", () => {
      if (this.quantityElement.value < this.inputMaxThreshold) {
        this.quantityElement.stepUp();
        this.quantityElement.dispatchEvent(new Event("change"));
      }
    });

    this.addQuantityEvent();
  }

  addQuantityEvent() {
    this.quantityElement.addEventListener("change", () => {
      if (this.quantityElement.value < this.inputMinThreshold || this.quantityElement.value == "") {
        this.quantityElement.value = this.inputMinThreshold;
      } else if (this.quantityElement.value > this.inputMaxThreshold) {
        this.quantityElement.value = this.inputMaxThreshold;
      }

      this.updateQuantity();

      this.plusButton.disabled = this.quantityElement.value >= this.inputMaxThreshold;

      this.url = this.element.dataset.cartUrl;
      this.postUpdatedQuantity();
    });
  }

  postUpdatedQuantity(method = "POST") {
    const formData = new FormData();
    formData.append("quantity", this.quantityElement.value);

    if (this.paymentWrapper) {
      this.paymentWrapper.classList.add("is-loading");
    }

    fetch(this.url, {
      retries: 3,
      retryDelay: 1000,
      method: method,
      headers: {
        Accept: "application/json",
      },
      body: formData,
    })
      .then(async (response) => {
        this.response = response;

        if (response.status === 200 || response.status === 422) {
          return response.json().catch(() => null);
        }

        throw new Error("Error adding product to cart");
      })
      .then((response) => {
        if (response === null) {
          return;
        }

        if (this.response.status === 422) {
          // we check if there is a new error message passed from the server
          this.revertQuantity();

          if (response.error) {
            displayToast(response.error);
          } else {
            displayToast(this.element.dataset.errorMessage);
          }

          return;
        }

        if (this.qvHeaderElement) {
          this.qvHeaderElement.dispatchEvent(new Event("qv-update"));
        }

        if (this.element.dataset.dispatchEvent) {
          window.dispatchEvent(new CustomEvent(this.element.dataset.dispatchEvent, { detail: response }));
        }

        if (this.totalQvAndProducts) {
          this.totalQvAndProducts.forEach((element) => {
            if (response.totalQvAndProducts) {
              element.innerHTML = response.totalQvAndProducts;
            }
            if (response.cart?.totalQvAndProducts) {
              element.innerHTML = response.cart.totalQvAndProducts;
            }
          });
        }

        if (method === "DELETE") {
          this.element.dispatchEvent(new CustomEvent("item-removed", { detail: response }));
        } else if (this.paymentWrapper) {
          this.element.dispatchEvent(new CustomEvent("quantity-changed", { detail: response }));
        }

        if (this.paymentWrapper) {
          this.paymentWrapper.classList.remove("is-loading");
        } else {
          window.dispatchEvent(new CustomEvent("cart-updated", { detail: response }));
          this.element.dispatchEvent(new CustomEvent("product-quantity-updated"));
        }

        this.oldValue = this.quantityElement.value;
      })
      .catch((e) => {
        this.revertQuantity();

        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "AddToCartBase", {
          response: this.response,
        });
      });
  }

  revertQuantity() {
    this.quantityElement.value = this.oldValue;
    this.plusButton.disabled = this.quantityElement.value >= this.inputMaxThreshold;
    this.updateQuantity();
  }

  updateQuantity() {
    this.element.classList.toggle("has-quantity", this.quantityElement.value > this.inputMinThreshold);
    this.element.classList.toggle("removeable", this.quantityElement.value === "1");

    // class instead of atribute since we want to keep the event listener
    this.minusButton?.classList.toggle("disabled", this.quantityElement.value <= this.inputMinThreshold);

    if (this.addToCartToggle) {
      this.addToCartToggle.innerHTML = this.quantityElement.value;
    }
  }
}
